<div>
    <div mat-dialog-title>
        <h1 style="text-transform: none; display: flex; justify-content: space-between;">
            <span>{{title}}</span>
            <mat-icon (click)="this.logoutOnClose ? auth.logout({ logoutParams: { returnTo: this.logoutUrl } }) : this.closeDialog()" style="cursor: pointer; color: gray;">close</mat-icon>
        </h1>
    </div>


    <div mat-dialog-content>
        <p style="white-space: pre-line;" [innerHTML]="message"></p>
    </div>

    <div *ngIf="input" mat-dialog-actions id="buttonsContainer">
        <div>
            <button class="buttonFont imageButton" (click)="onConfirm();">{{input}}</button>
        </div>
    </div>

    <div *ngIf="footermessage" mat-dialog-content>
        <h5 style="white-space: pre-line;">{{footermessage}}</h5>
        <div>
            <button style="height: 30px;" class="logoutButton"  (click)="this.logoutOnClose ? auth.logout({ logoutParams: { returnTo: this.logoutUrl } }) : this.closeDialog()">{{this.logoutOnClose ? 'Log Out' : 'Close'}}</button>
        </div>
    </div>
</div>